/* LOOKEE® motion core, shared by every page (rules: lookee-theme/MOTION_RULES.md).
   One idea runs through it: the orange dot is the reading. Motion is short, calm and always ends still.
   - Scroll motions are pure functions of a section's progress (--mp, 0 to 1): no timers, no carried state.
   - Entrances run once with the motion tokens (150, 250, 600, 900 ms) and the settle easing.
   - Still page, fully readable: the system's reduce-motion setting, the footer switch (html[data-motion="off"]),
     the theme editor, or any script error. Ideas rebuilt from the Animmaster pack: text-17 (rise), text-15
     (sweep), text-10 (focus rows), scroll-33 (drawn line), scroll-51 and hero-9 (opening frames), grid-1 (Flip). */
(function () {
  if (window.__lkCore) return;
  window.__lkCore = true;

  var html = document.documentElement;
  var LK = window.LK || (window.LK = {});
  var design = !!(window.Shopify && window.Shopify.designMode) || !!LK.designMode;
  var mq = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function still() { return design || mq.matches || html.getAttribute('data-motion') === 'off'; }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  var M = LK.m = {
    still: still,
    ease: { settle: 'cubic-bezier(.22, 1, .36, 1)', std: 'cubic-bezier(.65, 0, .35, 1)' },
    ms: { fast: 150, base: 250, slow: 600, xslow: 900 },
    /* closed-form spring (damping 0.8, about 1.5% overshoot): position at time t (s) toward 1 */
    spring: function (t, w) { w = w || 14; var z = 0.8, wd = w * Math.sqrt(1 - z * z); return 1 - Math.exp(-z * w * t) * (Math.cos(wd * t) + (z * w / wd) * Math.sin(wd * t)); }
  };

  /* ------------------------------------------------------------------ what gets which motion
     Selectors, so the sections keep their markup. The homepage (.ln) has its own motion in lk-home.js. */
  var RISE = '.chapter .h2, .plp__title, .ch__title, .st__title, .reg__title, .bn__title, .vd .h2';
  var RULE = '.chapter > .wrap > .rule';
  var STAGGER = '.cards, .numerals, .factlist, .steps4, .res__list, .ch__ways, .ch__offices, .ticks--rows, .lkf__cols';
  var SWEEP = '.quote blockquote, .ln-quote blockquote, .st__slide blockquote';
  var FOCUS = '.factlist, .ticks--rows';
  var PHONE = '.shot--phone';
  var LINE_X = '.steps4';
  var OPEN = '.bn__media';
  var COUNT = '.numeral';

  /* ------------------------------------------------------------------ headings rise word by word */
  function splitWords(el) {
    if (el.__mSplit) return;
    el.__mSplit = true;
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var parts = n.textContent.split(/(\s+)/), frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var w = document.createElement('span'); w.className = 'm-w';
            var inner = document.createElement('span'); inner.textContent = p; inner.style.setProperty('--i', i++);
            w.appendChild(inner); frag.appendChild(w);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !/^(SUP|SVG|IMG|BR)$/i.test(n.tagName) && !n.classList.contains('m-w') && !n.classList.contains('reg')) {
          walk(n);
        }
      });
    })(el);
    // a ® right after a word rides with that word, so it never wraps onto a line of its own
    $$('.reg', el).forEach(function (r) {
      var prev = r.previousSibling;
      if (prev && prev.nodeType === 1 && prev.classList.contains('m-w') && prev.firstChild) prev.firstChild.appendChild(r);
    });
  }

  /* ------------------------------------------------------------------ a line of colour uncovers each line */
  function sweep(el) {
    if (el.__mSwept) return;
    el.__mSwept = true;
    if (still()) return;
    var text = el.innerHTML;
    splitWords(el);
    var words = $$('.m-w', el), lines = [], top = null;
    words.forEach(function (w) { var t = w.offsetTop; if (top === null || Math.abs(t - top) > 4) { lines.push([]); top = t; } lines[lines.length - 1].push(w); });
    lines.forEach(function (ws, li) {
      var line = document.createElement('span'); line.className = 'm-line'; line.style.setProperty('--l', li);
      ws[0].parentNode.insertBefore(line, ws[0]);
      ws.forEach(function (w, k) { if (k) { var prev = w.previousSibling; if (prev && prev.nodeType === 3) line.appendChild(prev); } line.appendChild(w); });
    });
    el.classList.add('m-sweep');
    var done = 700 + lines.length * 90 + 200;
    el.__mDone = function () { setTimeout(function () { el.innerHTML = text; el.classList.remove('m-sweep'); }, done); };
  }

  /* ------------------------------------------------------------------ numbers count up once */
  function countUp(el) {
    var node = null;
    for (var c = el.firstChild; c; c = c.nextSibling) { if (c.nodeType === 3 && c.textContent.trim()) { node = c; break; } }
    if (!node) return;
    var raw = node.textContent.trim(), m = raw.match(/^(\d{1,3}(?:\.\d)?)$/);
    if (!m || still()) return;
    var target = parseFloat(m[1]), dec = (m[1].split('.')[1] || '').length, t0 = performance.now();
    node.textContent = (0).toFixed(dec);
    (function tick(t) {
      var p = Math.min(1, (t - t0) / M.ms.xslow), e = 1 - Math.pow(1 - p, 3);
      node.textContent = (target * e).toFixed(dec);
      if (p < 1) requestAnimationFrame(tick); else node.textContent = raw;
    })(t0);
  }

  /* ------------------------------------------------------------------ entrances, once */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      enter(e.target);
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -10% 0px' }) : null;

  function enter(el) {
    if (el.classList.contains('m-in')) return;
    el.classList.add('m-in');
    if (el.__mCount) countUp(el);
    if (el.__mDone) el.__mDone();
  }

  function tag(scope) {
    scope = scope || document;
    $$(RISE, scope).forEach(function (el) { if (el.closest('.ln')) return; if (!still()) splitWords(el); el.setAttribute('data-m', 'rise'); watch(el); });
    $$(RULE, scope).forEach(function (el) { el.setAttribute('data-m', 'rule'); watch(el); });
    $$(STAGGER, scope).forEach(function (el) {
      el.setAttribute('data-m-stagger', '');
      Array.prototype.forEach.call(el.children, function (c, i) { c.style.setProperty('--si', Math.min(i, 8)); });
      watch(el);
    });
    $$(SWEEP, scope).forEach(function (el) { el.setAttribute('data-m', 'sweep'); watch(el); });
    $$(PHONE, scope).forEach(function (el) { el.setAttribute('data-m', 'wake'); watch(el); });
    $$(COUNT, scope).forEach(function (el) { el.__mCount = true; watch(el); });
    $$(LINE_X, scope).forEach(function (el) { el.setAttribute('data-m-line', 'x'); el.setAttribute('data-mp', ''); });
    $$(OPEN, scope).forEach(function (el) { el.setAttribute('data-m-open', 'window'); el.setAttribute('data-mp', ''); });
    $$(FOCUS, scope).forEach(function (el) { el.setAttribute('data-m-focus', ''); });
    $$('[data-mp]', scope).forEach(function (el) { if (progressEls.indexOf(el) < 0) progressEls.push(el); });
    $$('[data-m-focus]', scope).forEach(function (el) { if (focusEls.indexOf(el) < 0) focusEls.push(el); });
  }
  function watch(el) {
    if (el.__mWatch) return;
    el.__mWatch = true;
    if (el.getAttribute('data-m') === 'sweep') sweepQueue.push(el);
    if (still() || !io) { enter(el); return; }
    io.observe(el);
  }
  var sweepQueue = [];

  /* ------------------------------------------------------------------ scroll progress (--mp) and focus rows */
  var progressEls = [], focusEls = [], ticking = false;
  function frame() {
    ticking = false;
    var vh = window.innerHeight, mid = vh / 2, off = still();
    progressEls.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -vh || r.top > vh * 2) return;
      // 0 when the top edge reaches the bottom of the screen, 1 when it reaches 30% from the top;
      // data-mp="through": how far the reading line (60% down the screen) has travelled through the element
      var p = off ? 1 : el.getAttribute('data-mp') === 'through'
        ? clamp((vh * 0.6 - r.top) / Math.max(r.height, 1), 0, 1)
        : clamp((vh - r.top) / (vh * 0.7), 0, 1);
      el.style.setProperty('--mp', p.toFixed(3));
    });
    focusEls.forEach(function (list) {
      Array.prototype.forEach.call(list.children, function (row) {
        var r = row.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var d = off ? 0 : clamp(Math.abs((r.top + r.bottom) / 2 - mid) / (vh * 0.55), 0, 1);
        row.style.setProperty('--fd', d.toFixed(3));
      });
    });
    rail();
  }
  function queue() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }

  /* ------------------------------------------------------------------ the reading rail (homepage, wide screens)
     A hairline in the left margin; the orange dot marks how far through the night the page is. */
  var railEl = null, railDot = null, railStart = 0, railEnd = 1;
  function buildRail() {
    if (!document.body.classList.contains('ln-page') || railEl) return;
    var first = document.querySelector('.ln-hero'), last = document.querySelector('.ln-brand') || document.querySelector('footer');
    if (!first || !last) return;
    railEl = document.createElement('div'); railEl.className = 'm-rail'; railEl.setAttribute('aria-hidden', 'true');
    railDot = document.createElement('i'); railEl.appendChild(railDot);
    $$('.ln').forEach(function (s) { if (s === first) return; var t = document.createElement('b'); t.__sec = s; railEl.appendChild(t); });
    document.body.appendChild(railEl);
    measureRail();
  }
  function measureRail() {
    if (!railEl) return;
    var first = document.querySelector('.ln-hero'), last = document.querySelector('.ln-brand') || document.querySelector('footer');
    railStart = first.getBoundingClientRect().bottom + window.scrollY - window.innerHeight * 0.4;
    railEnd = Math.max(railStart + 1, last.getBoundingClientRect().top + window.scrollY - window.innerHeight * 0.4);
    $$('b', railEl).forEach(function (t) {
      var y = t.__sec.getBoundingClientRect().top + window.scrollY - window.innerHeight * 0.4;
      t.style.setProperty('--t', clamp((y - railStart) / (railEnd - railStart), 0, 1).toFixed(4));
    });
  }
  function rail() {
    if (!railEl) return;
    var p = clamp((window.scrollY - railStart) / (railEnd - railStart), 0, 1);
    railEl.style.setProperty('--rp', p.toFixed(4));
    railEl.classList.toggle('is-on', window.scrollY > railStart - 40 && window.scrollY < railEnd + window.innerHeight * 0.3);
  }

  /* ------------------------------------------------------------------ Flip: things glide to their new place */
  M.flip = function (items, mutate) {
    if (still() || !items.length || !Element.prototype.animate) { mutate(); return; }
    var before = items.map(function (el) { return el.getBoundingClientRect(); });
    mutate();
    requestAnimationFrame(function () {
      items.forEach(function (el, i) {
        if (el.offsetParent === null) return;
        var a = before[i], b = el.getBoundingClientRect();
        if (!a.width && !a.height) { el.animate([{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'none' }], { duration: M.ms.slow, easing: M.ease.settle }); return; }
        var dx = a.left - b.left, dy = a.top - b.top;
        if (Math.abs(dx) < 1 && Math.abs(dy) < 1) return;
        el.animate([{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'none' }], { duration: M.ms.slow, easing: M.ease.settle });
      });
    });
  };
  /* filters that hide items in place: testimonials topics, user manual search */
  function flipOn(trigger, evt, itemsSel) {
    document.addEventListener(evt, function (e) {
      var t = e.target.closest ? e.target.closest(trigger) : null;
      if (!t || still()) return;
      var items = $$(itemsSel);
      var before = items.map(function (el) { return el.offsetParent === null ? null : el.getBoundingClientRect(); });
      setTimeout(function () {
        items.forEach(function (el, i) {
          if (el.offsetParent === null || !el.animate) return;
          var a = before[i], b = el.getBoundingClientRect();
          if (!a) { el.animate([{ opacity: 0, transform: 'scale(.97)' }, { opacity: 1, transform: 'none' }], { duration: M.ms.slow, easing: M.ease.settle }); return; }
          var dx = a.left - b.left, dy = a.top - b.top;
          if (Math.abs(dx) > 1 || Math.abs(dy) > 1) el.animate([{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'none' }], { duration: M.ms.slow, easing: M.ease.settle });
        });
      }, 0);
    }, true);
  }

  /* ------------------------------------------------------------------ add to cart: a drawn tick, the count ticks up */
  var lastBuy = null;
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('button[name="add"], [data-add], [data-add-to-cart]') : null;
    if (b) lastBuy = { el: b, t: Date.now() };
  }, true);
  function added() {
    if (lastBuy && Date.now() - lastBuy.t < 8000 && !still()) {
      var b = lastBuy.el;
      // after the button has written its own "Added" label, a tick draws itself in front of it
      setTimeout(function () {
        if (!b.querySelector('.m-tick')) {
          var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          s.setAttribute('class', 'm-tick'); s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('aria-hidden', 'true');
          var p = document.createElementNS('http://www.w3.org/2000/svg', 'path'); p.setAttribute('d', 'M5 12.5l4.2 4.2L19 7'); p.setAttribute('pathLength', '1');
          s.appendChild(p); b.insertBefore(s, b.firstChild);
        }
        b.classList.remove('m-added'); void b.offsetWidth; b.classList.add('m-added');
        setTimeout(function () { b.classList.remove('m-added'); var t = b.querySelector('.m-tick'); if (t) t.remove(); }, 2200);
      }, 60);
    }
    lastBuy = null;
    $$('[data-cart-count], .header__util[data-cart-open]').forEach(function (c) {
      if (still() || !c.animate) return;
      c.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.12)' }, { transform: 'scale(1)' }], { duration: M.ms.slow, easing: M.ease.settle });
    });
  }
  document.addEventListener('lk:cart:added', added);
  document.addEventListener('lk:cart', function () { if (lastBuy) added(); });

  /* ------------------------------------------------------------------ videos open from the play button */
  document.addEventListener('click', function (e) {
    var play = e.target.closest ? e.target.closest('.vd__play') : null;
    if (!play || still()) return;
    var box = play.closest('.vd__screen') || play.closest('.vd__stage');
    if (!box || !box.animate) return;
    var r = box.getBoundingClientRect(), p = play.getBoundingClientRect();
    var ins = [p.top - r.top, r.right - p.right, r.bottom - p.bottom, p.left - r.left].map(function (v) { return Math.max(0, v) + 'px'; }).join(' ');
    box.animate([{ clipPath: 'inset(' + ins + ' round 999px)' }, { clipPath: 'inset(0 0 0 0 round 20px)' }], { duration: M.ms.slow, easing: M.ease.settle });
  });

  /* ------------------------------------------------------------------ switch on and off */
  function sync() {
    var off = still();
    html.classList.toggle('m-on', !off);
    if (off) { $$('[data-m], [data-m-stagger]').forEach(function (el) { el.classList.add('m-in'); }); }
    queue();
  }
  document.addEventListener('lk:motion', function () { setTimeout(sync, 0); });
  if (mq.addEventListener) mq.addEventListener('change', sync);

  function start() {
    try {
      sync();
      tag();
      buildRail();
      flipOn('.st__chip', 'click', '.st__card');
      flipOn('.res__search input', 'input', '.res__item');
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', function () { measureRail(); queue(); }, { passive: true });
      window.addEventListener('load', function () { measureRail(); queue(); });
      queue();
      // failsafe: anything on screen or above it is shown after 1.5 s, whatever happened
      setTimeout(function () {
        $$('[data-m], [data-m-stagger]').forEach(function (el) { if (!el.classList.contains('m-in') && el.getBoundingClientRect().top < window.innerHeight) enter(el); });
      }, 1500);
    } catch (err) {
      html.classList.remove('m-on');
    }
  }
  // sweeps measure lines, so they wait for the fonts
  function prepSweeps() { sweepQueue.forEach(function (el) { if (!el.classList.contains('m-in')) sweep(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(prepSweeps); else window.addEventListener('load', prepSweeps);

  document.addEventListener('shopify:section:load', function (e) { tag(e.target); sync(); });
})();
